import { useMemo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

type UseSingleSelectFilterDisplayTextParams = {
    defaultSelectionKey: string;
    isDefaultSelected: boolean;
    nonDefaultSelectionKey: string;
    selectionKey: string | null;
};

export const useSingleSelectFilterDisplayText = ({
    defaultSelectionKey,
    isDefaultSelected,
    nonDefaultSelectionKey,
    selectionKey,
}: UseSingleSelectFilterDisplayTextParams) => {
    const { translate } = useTranslate();

    return useMemo(() => {
        if (isDefaultSelected) {
            return translate(defaultSelectionKey);
        }

        return translate(nonDefaultSelectionKey, {
            selection: selectionKey ? translate(selectionKey) : "",
        });
    }, [isDefaultSelected, selectionKey, translate, defaultSelectionKey, nonDefaultSelectionKey]);
};
